import useQueryStringBoolean from '@common/utils/useQueryStringBoolean';
import React, { useEffect } from "react";
import GiftCardBalanceModal from '../product/GiftCardBalanceModal';
import { appPostStructuredMessage } from '@common/utils/appUtils';
const GiftcardBalanceFAQ = (props) => {
    const { results } = props;
    const [checkBalance, setCheckBalance] = useQueryStringBoolean('checkBalance');
    useEffect(() => {
        document.querySelectorAll('.gc-balance-show').forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                setCheckBalance(true);
            });
        });
    }, [results]);
    useEffect(() => {
        if (checkBalance && window.appmode) {
            appPostStructuredMessage('gc_check_balance', {});
        }
    }, [checkBalance]);
    return React.createElement(React.Fragment, null,
        React.createElement(GiftCardBalanceModal, { isOpen: checkBalance, onRequestClose: () => setCheckBalance(false) }));
};
export default GiftcardBalanceFAQ;
